<template>
    <div>
        <CRow>
            <CCol md="12">
                <CCard>
                    <CCardHeader>
                        <CRow>
                            <CCol col="2">
                                <strong>{{ $t('AccountCirculation') }}</strong>

                            </CCol>
                            <CCol col="3">
                                <CSelect
                                        :label="$t('Year')"
                                        horizontal
                                        :value.sync="selected_year"
                                        :options="years_list"
                                />

                            </CCol>
                        </CRow>
                    </CCardHeader>
                    <CCardBody>
                        <CRow class="m-1">
                            <CCol col="3">

                                <CSelect
                                        :value.sync="selected_tafsili_type"
                                        :options="tafsili_types"
                                        :placeholder="$t('type')"
                                />
                            </CCol>
                            <CCol col="3">

                                <treeselect
                                        v-model="selected_person"
                                        :options="moein_list"
                                        :async="sync_person"
                                        :load-options="load_persons"
                                        :cacheOptions='false'
                                        :normalizer="normalizer_persons"
                                        @select="select_user"
                                        :placeholder="$t('search')"
                                />
                            </CCol>
                          <CCol col="3">
                            <CustomMonthPicker
                                v-model="start_date"
                                :value.sync="start_date"
                            />
                          </CCol>

                            <CCol col="1">
                                <CButton @click="get_lists" color="dark"
                                         size="sm">
                                    <CIcon size="sm" name="cil-zoom"/>
                                </CButton>
                            </CCol>
                            <!--              <CCol col="3">-->
                            <!--                <date-picker-->
                            <!--                        :label="$t('components.startDate')"-->
                            <!--                        v-model="start_date"></date-picker>-->
                            <!--              </CCol>-->
                            <!--              <CCol col="3">-->
                            <!--                <date-picker-->
                            <!--                        :label="$t('components.endDate')"-->
                            <!--                        v-model="end_date"></date-picker>-->

                            <!--              </CCol>-->

                        </CRow>
                        <CDataTable
                                :items="items"
                                :fields="fields"
                                :items-per-page="200"
                                hover
                                border
                                :pagination="get_pagination"
                                striped
                        >
                            <template #row_id="{item,index}">

                                <td :style="get_style(item)">
                                    <p class="text-center">{{ index + 1 }}</p>

                                </td>

                            </template>

                            <template #amount="{item}">
                                <td :style="get_style(item)+'text-align:right'">
                                    <p style="text-align:right">{{ get_currency(item.amount) }}</p>
                                </td>
                            </template>
                            <template #docDate="{item}">
                                <td :style="get_style(item)">
                                    <p v-if="item.personAccountId!=0" style="text-align: center">{{
                                        get_date(item.docDate) }}</p>
                                    <p v-else></p>
                                </td>
                            </template>
                            <template #amountNegetive="{item}">
                                <td :style="get_style(item)+'text-align:right'">
                                    <p style="text-align:right">{{ get_currency(item.amountNegetive) }}</p>
                                </td>
                            </template>
                            <template #balanceBefore="{item}">
                                <td :style="get_style(item)+'text-align:right'">
                                    <p style="text-align:right" v-if="item.balanceBefore!=null">
                                        {{get_currency(item.balanceBefore)}}</p>
                                </td>
                            </template>
                            <!--              <template #accBalance="{item}">-->
                            <!--                <td :style="get_style(item)+'text-align:right'">-->
                            <!--                  <p v-if="item.amount>item.amountNegetive" style="text-align:right">{{ get_currency(item.accBalance) }}</p>-->
                            <!--                  <p v-else style="text-align:right">{{ get_currency(item.accBalanceNegetive) }}</p>-->
                            <!--                </td>-->
                            <!--              </template>-->


                            <template #accBalance="{item}">
                                <td>
                                    <p :style="'text-align:right; '+get_style_price(item,'accBalance')" >{{ get_currency(Math.abs(item.accBalance)) }}</p>
                                </td>
                            </template>
                            <template #kardexAccTypeTitle="{item}">
                                <td :style="get_style(item)">
                                    <p>{{ item.statusTitle }}</p>
                                </td>
                            </template>

                            <template #masterId="{item}">
                                <td  :style="get_style(item)">
                                    <a v-if="item.personAccountId!=0" href="javascript:void(0)" class="text-primary"
                                       v-on:click="goToDocuments(item)">
                                        {{ item.masterCode }}
                                    </a>
                                  <a v-if="item.payDocCode!=null" href="javascript:void(0)" class="text-primary"
                                     v-on:click="goToAccountingDocPay(item)">
                                   - {{ item.payDocCode }}
                                  </a>

                                  <a v-if="item.accNo!=null" href="javascript:void(0)" class="text-primary"
                                     v-on:click="goToAccountingDoc(item)">
                                    - {{ item.accNo }}
                                  </a>
                                </td>

                            </template>

                            <template #summary="{item}">
                                <td>
                                    <p v-if="item.summary != 'null'">{{ item.summary }}</p>
                                </td>

                            </template>


                            <template #sumExistanceP="{item}">
                                <td>
                                    <p v-if="item.sumExistance>0">{{ item.sumExistance }}</p>
                                    <p v-else>0</p>
                                </td>
                            </template>
                            <template #sumExistanceN="{item}">
                                <td>
                                    <p v-if="item.sumExistance<=0">{{ Math.abs(item.sumExistance) }}</p>
                                    <p v-else>0</p>

                                </td>
                            </template>
                            <template #sumAmountP="{item}">
                                <td>
                                    <p v-if="item.sumAmount>0">{{ item.sumAmount }}</p>
                                    <p v-else>0</p>

                                </td>
                            </template>

                            <template #sumAmountN="{item}">
                                <td>
                                    <p v-if="item.sumAmount<=0">{{ Math.abs(item.sumAmount) }}</p>
                                    <p v-else>0</p>
                                </td>
                            </template>


                            <template #under-table>
                                <CRow>
                                    <CCol></CCol>
                                    <CCol></CCol>
                                    <CCol></CCol>
                                    <CCol></CCol>
                                    <CCol>{{ $t('totalCirculation') }}</CCol>
                                    <CCol>{{ get_currency(calculate_items(items,'amountNegetive')) }}</CCol>
                                    <CCol>{{ get_currency(calculate_items(items,'amount')) }}</CCol>
                                    <CCol></CCol>
                                    <CCol></CCol>

                                </CRow>
                                <CRow>
                                    <CCol></CCol>
                                    <CCol></CCol>
                                    <CCol></CCol>
                                    <CCol></CCol>
                                    <CCol class="bg-dark">{{ $t('tables.balance') }}</CCol>
                                    <CCol class="bg-dark" v-if="items[0].natureId==2">{{ get_currency(Math.abs(-calculate_items(items,'amount') +
                                        calculate_items(items,'amountNegetive')  + calculate_items(items.filter(x=>x.personAccountId==0),'accBalance')))}}
                                    </CCol>
<!--                                    <CCol class="bg-dark" v-else>{{ get_currency(-calculate_items(items,'amount') +-->
<!--                                        calculate_items(items,'amountNegetive')  + calculate_items(items.filter(x=>x.personAccountId==0),'accBalance'))}}-->
<!--                                    </CCol>-->
                                    <CCol class="bg-dark text-danger" v-if="items[0].natureId!=2 && (-calculate_items(items,'amount') +
                                        calculate_items(items,'amountNegetive')  + calculate_items(items.filter(x=>x.personAccountId==0),'accBalance'))<0">{{ get_currency(Math.abs(-calculate_items(items,'amount') +
                                        calculate_items(items,'amountNegetive')  + calculate_items(items.filter(x=>x.personAccountId==0),'accBalance')))}}
                                    </CCol>
                                    <CCol class="bg-dark" v-if="items[0].natureId!=2 && (-calculate_items(items,'amount') +
                                        calculate_items(items,'amountNegetive')  + calculate_items(items.filter(x=>x.personAccountId==0),'accBalance'))>0">{{ get_currency(-calculate_items(items,'amount') +
                                        calculate_items(items,'amountNegetive')  + calculate_items(items.filter(x=>x.personAccountId==0),'accBalance'))}}
                                    </CCol>
                                    <CCol></CCol>
                                    <CCol></CCol>

                                    <CCol></CCol>
                                </CRow>

                            </template>
                        </CDataTable>
                    </CCardBody>
                    <CCardFooter>

                    </CCardFooter>
                </CCard>
            </CCol>
        </CRow>
      <CModal
          :show.sync="show_factor_detail"
          :no-close-on-backdrop="true"
          :centered="true"
          :title="$t('InventoryBill')"
          size="lg"
          color="dark"
      >
        <CCard id="printMe">
          <ShowPayReceiveDocs :doc_id="selected_doc_id"/>

        </CCard>


        <template #footer>

          <CButton
              @click="show_factor_detail = false"
              color="success"
          >{{ $t("buttons.close") }}
          </CButton>
        </template>
      </CModal>

    </div>
</template>

<script>
    import axios from "axios";
    import {bus} from '../../../../main';
    // import the styles
    import ShowPayReceiveDocs from "../ShowPayReceiveDocs.vue";
    import Treeselect from '@riophae/vue-treeselect'
    // import the styles
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import {ASYNC_SEARCH} from '@riophae/vue-treeselect'
    import moment from 'moment-jalaali'
import CustomMonthPicker from "../../includes/CustomMonthPicker.vue";
    var simulateAsync=null
    const simulateAsyncOperation = fn => {
        if(simulateAsync!=null){
            clearTimeout(simulateAsync)
        }
        simulateAsync =  setTimeout(fn, 1000)
    }
    var items = [];


    export default {
        name: 'Login',
        components: {
            Treeselect,
          CustomMonthPicker,
          ShowPayReceiveDocs
        },
        data() {
            return {
              show_factor_detail: false,
              selected_doc_id: null,
                confirm_delete_name: "confirm" + new Date().getTime() + "_" + this.$vnode.tag,
                selected_year: "2023",
              years_list: [],
                selected_tafsili_type: 2,
                //tasiliType 0 =>Other, 1=> Personal, 2=> Customers, 3=> Sellers, 4=> Persons, 5=> Bank,, 6=> CashBox,

                tafsili_types: [
                    {label: this.$t('Other'), value: 0},
                    {label: this.$t('Customers'), value: 2},
                    {label: this.$t('Suppliers'), value: 3},
                    {label: this.$t('BankPost'), value: 5},
                    {label: this.$t('cash'), value: 6},
                    {label: this.$t('sidebars.personal'), value: 1},

                ],
                validate_errors: [],
                selected_level: '',
                start_date: '',
                end_date: '',

                items: items.map((item, row_id) => {
                    return {...item, row_id}
                }),
                fields: [
                    {key: 'row_id', label: this.$t('tables.row'), sorter: false, _style: 'width:5%'},
                    {key: 'docDate', label: this.$t('date'), _style: 'width:10%'},
                    {key: 'kardexAccTypeTitle', label: this.$t('documentType'), _style: 'width:10%'},
                    {key: 'masterId', label: this.$t('reference'), _style: 'width:10%'},
                    {key: 'amountNegetive', label: this.$t('tables.debtor'), _style: 'width:10%'},
                    {key: 'amount', label: this.$t('tables.creditor'), _style: 'width:10%'},
                    {key: 'accBalance', label: this.$t('tables.balance'), _style: 'width:10%'},
                ],

                status_form: 0,

                selected_person_name: '',
                selected_person: null,
                person_async_list: [],
                sync_person: true,
                person_name: '',
                accounting_list: [],
                moein_list: [],

                normalizer_persons(node) {
                    return {
                        id: node.itemId,
                        label: node.itemCode + " " + node.itemName,
                    }
                },

            }
        },
        created() {
        },
        mounted() {
          if(this.get_access("persons_in_turnover")){
            this.tafsili_types.push({label: this.$t('persons'), value: 4})
          }
          this.get_years();
            this.$root.root_validate_errors = [];
          this.start_date = moment().locale(this.$i18n.locale).format('YYYY-MM-DD');
            this.end_date = this.get_today();
            bus.$on("finance_report_selected", (data) => {
                console.log(data);
                this.sync_person = false;
                this.selected_tafsili_type = data.tafsiliType
                this.moein_list = [{
                    itemId: data.personId,
                    itemCode: data.personCode,
                    itemName: data.personName
                }];
                setTimeout(() => {
                    this.selected_person = data.personId;
                    this.selected_person_name = data.personCode + " " + data.personName;
                    this.get_lists();
                }, 300);
                setTimeout(() => {
                    this.sync_person = true;
                }, 1000);
            });
            // this.get_lists();
            this.get_lists_groups();
        },
      watch: {
            'selected_tafsili_type': function () {

                this.selected_person = null
            }
        },
        methods: {
          goToAccountingDocPay(item) {
            this.show_factor_detail = true
            this.selected_doc_id = item.payDocId
          },
          goToAccountingDoc(item) {
            window.open('/dashboard/accounting/show-accounting-doc/'+item.payAccId)
          },
          get_years() {
            var self = this;

            const formData = new FormData();
            // formData.append('id', this.selected_province);
            axios.post('GetFiscalYears', formData, {}).then(function (response) {


              var content_data = response.data;

              // items = content_cats.orders;
              if (content_data.statusCode == 0) {

                self.years_list = self.sort_array([], content_data.data, "id", "title")
                self.selected_year = self.years_list.filter(x => x.isActive == 1)[0].value
              }

            }).catch(function (error) {
              console.log(error);
            });

          },

          load_persons({action, searchQuery, callback}) {
                var self = this;
                if (action === ASYNC_SEARCH) {
                    simulateAsyncOperation(() => {
                        let options;
                        const formData = new FormData();

                        formData.append('SearchTxt', searchQuery);
                        var url = "GetTafsiliInfoByParam";

                        formData.append('Id', 0);
                        formData.append('TypeId', self.selected_tafsili_type);
                        formData.append('IsActive', 0);

                        axios.post(url, formData, {show_pros: true}).then(function (response) {
                            options = response.data.data;

                            callback(null, options);

                        })
                            .catch(function (error) {

                                console.log(error);
                            });

                    })
                }
            },
            get_style(item) {
                var color = '#56ff42';
                if (item.personAccountId == 0) {
                    // return 'backgroundColor: \'#56ff42\'';
                    return {
                        backgroundColor: color
                    }
                }
            },
            get_style_price(item, index) {
                var color = '#ff1403';
                if(item.natureId==1){
                    if (parseFloat(item[index]) < 0) {
                        return 'color:#ff1403;'
                    }
                }
                if(item.natureId==2){
                    if (parseFloat(item[index]) > 0) {
                        return 'color:#ff1403;'
                    }
                }

            },
            select_user(node, instance) {
                this.selected_person_name = node.fullName + " " + node.personCode;

            },
            get_lists() {
                var self = this;

                const formData = new FormData();

              var s_year = this.years_list.filter(x=>x.value==this.selected_year)[0].label;
              var start_end_date =  this.get_fisrt_last_month(s_year,this.start_date);

              // date.setFullYear(this.selected_year,this.start_date,1);
              // date2.setFullYear(this.selected_year,this.start_date,1);
              // var last_day2 = new Date(date2)
              // var last_day = new Date(last_day2.getFullYear(), last_day2.getMonth() + 1, 0)

              // moment(date).locale('en').format('YYYY-MM-DD')
              formData.append('FromDate',start_end_date[0]);
              formData.append('ToDate', start_end_date[1]);
              // formData.append('FromDate', moment(date).locale('en').format('YYYY-MM-DD'));
              // formData.append('ToDate', moment(last_day).locale('en').format('YYYY-MM-DD'));
              formData.append('YearDate', this.selected_year);


                formData.append('TafsiliType', this.selected_tafsili_type);
                formData.append('id', this.selected_person);
                if(this.selected_person==null){
                    return false;}
                formData.append('PartyId', this.selected_person);
                formData.append('ParentId', 10);
                formData.append('ChildId', 10);
                axios.post('GetPersonAccountsByPersonId_New', formData, {}).then(function (response) {

                    var content_data = response.data;

                    // items = content_cats.orders;
                    if (content_data.statusCode == 0) {
                        self.items = content_data.data.personAccountItems.map((item, row_id) => {
                            return {...item, row_id}
                        });
                        self.items.forEach(function (val,index) {
                            if(index==0) {
                                val.reminingBefore = 0;
                                if(val.natureId==0 && self.items[index+1]!=null){
                                    val.natureId = self.items[index+1].natureId;
                                }
                                // val.accBalance = val.accBalance
                            }else{
                                val.reminingBefore = self.items[index-1].accBalance;

                                if(val.natureId==2){
                                    val.accBalance = parseFloat(val.reminingBefore) +  parseFloat(val.amount);
                                    // val.accBalanceFinal =val.accBalance
                                    if(val.amount>0){
                                        val.amountNegetive=Math.abs(val.amount);
                                        val.amount=0;

                                    }else{
                                        val.amount=Math.abs(val.amount);
                                        val.amountNegetive=0;
                                    }
                                }else{

                                    val.accBalance = parseFloat(val.reminingBefore)   + parseFloat(val.amount);
                                    if(val.amount<0){
                                        val.amountNegetive=0;
                                        val.amount=Math.abs(val.amount);

                                    }else{
                                        val.amountNegetive=Math.abs(val.amount);
                                        val.amount=0;

                                    }
                                }
                            }

                        })
                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

                    }

                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },
            get_lists_groups() {

                var self = this;
                self.items_parent = [];
                self.data_with_children = []

                const formData = new FormData();
                var url = "Get_AllAccountingGroups";

                axios.post(url, formData, {}).then(function (response) {

                        var content_data = response.data;

                        if (content_data.statusCode == 0) {

                            self.accounting_list = response.data.data
                            self.accounting_list.forEach((val) => {
                                if (val.parentId == 0) {

                                    self.get_childrens_one_sub(val.id, self.accounting_list).forEach((val2) => {

                                        self.get_childrens_one_sub(val2.id, self.accounting_list).forEach((val3) => {

                                            self.moein_list.push(val3)

                                        });

                                    });

                                }

                            });
                        } else {
                            self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

                        }

                    }
                )
                    .catch(function (error) {
                        console.log(error);
                    });

            },
            get_childrens_one_sub(parent_id, list) {
                var array = [];
                var self = this;
                list.forEach((val2) => {

                    if (parent_id == val2.parentId) {
                        // var obj = {label: val2.accountCode + " " + val2.accountName, value: val2.id, code: val2.accountCode}
                        array.push(val2);


                    }
                });
                return array;
            },
            goToDocuments(item) {
                window.open('/dashboard/documents/show/' + item.masterId)
                // this.$router.push({path: '/dashboard/documents/show/' + item.masterId});

            },
        }
    }

</script>
